import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b9f713f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-watermark-container" }
const _hoisted_2 = {
  class: "tutorial",
  href: "/help/watermark-decryption",
  target: "_blank"
}
const _hoisted_3 = { class: "cm-link-light" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

import { ref, reactive, onMounted, computed, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'
import { WatermarkType } from '@/views/dashboard/data-safe/screen-watermark/_enum/watermark-type'
import {
  getWatermarkFieldLabel,
  getWatermarkModeLabel,
  getWatermarkTypeLabel,
} from '@/views/dashboard/data-safe/screen-watermark/_enum/screen-watermark-labels'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import ScreenWatermarkEdit from '@/views/dashboard/data-safe/screen-watermark-edit/screen-watermark-edit.vue'
import { TableOptColumn } from '@/components/cmTable/types'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { StrategyListData } from './screen-watermark.service'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'screen-watermark',
  setup(__props) {

const { t, locale } = useI18n()

function watermarkTypeLabel (type: number) {
  void locale.value
  return getWatermarkTypeLabel(t, type)
}
function watermarkModeLabel (mode: number) {
  void locale.value
  return getWatermarkModeLabel(t, mode)
}
function watermarkFieldLabel (field: string) {
  void locale.value
  return getWatermarkFieldLabel(t, field)
}
const injector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = injector.get(PolicyCommonService)
const servicePermissionService = injector.get(ServicePermissionService)

const policyManageRef = ref()
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.watermark_screen)
const policyEditDrawerVisible = ref(false)
const policyEditPolicyId = ref('')

function handlePolicyAction({ type, rowItem }: { type: string; rowItem?: any }) {
  if (type === 'add' || type === 'edit') {
    policyEditPolicyId.value = type === 'edit' ? rowItem?.id ?? '' : ''
    policyEditDrawerVisible.value = true
  }
}

async function onPolicyEditSuccess() {
  policyEditDrawerVisible.value = false
  await nextTick()
  await policyManageRef.value?.tableRef?.getList?.()
  loadStatistics()
}

// --- Statistics Data ---
const statistics = reactive({
  totalStrategies: 14,
  visibleCount: 5,
  hiddenCount: 1,
  coverageGroups: 5
})

// 获取统计数据
function loadStatistics() {
  if (!hasPermission) return

  policyCommonService.getStrategyList({
    page: 1,
    limit: 99999,
    strategy_type: PolicyType.screenWatermark,
    group_id: -1,
    apply_group_id_search: false,
  }).then(res => {
    const data = res.data || []
    statistics.totalStrategies = data.length

    let visibleCount = 0
    let hiddenCount = 0
    const groupSet = new Set<string>()

    data.forEach((item: StrategyListData) => {
      // 统计显性/隐形水印
      if (item.strategy?.wmdata?.mark_type === WatermarkType.visible) {
        visibleCount++
      } else if (item.strategy?.wmdata?.mark_type === WatermarkType.hidden) {
        hiddenCount++
      }

      // 统计覆盖分组（从 group_name_list 中获取）
      if (item.group_name_list && Array.isArray(item.group_name_list)) {
        item.group_name_list.forEach(groupName => {
          if (groupName) {
            groupSet.add(groupName)
          }
        })
      }
    })

    statistics.visibleCount = visibleCount
    statistics.hiddenCount = hiddenCount
    statistics.coverageGroups = groupSet.size || data.reduce((sum: number, item: StrategyListDataCommon) => sum + (item.count || 0), 0)
  }).catch(() => {
    // 如果获取失败，使用默认值
  })
}

onMounted(() => {
  loadStatistics()
})

const customCols = computed<TableOptColumn[]>(() => [
  {
    prop: 'strategy.type',
    columnOpt: { minWidth: 90, },
  },
  {
    label: t('screenWatermark.watermarkContent'),
    prop: 'strategy.wmdata.fields',
    columnOpt: { minWidth: 190, },
  },
  {
    prop: 'strategy.wmdata.mark_type',
    columnOpt: { minWidth: 110, },
  },
])


return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageSubscribeBar, {
        "normal-permission-key": _unref(PermissionFe).watermark_screen
      }, null, 8, ["normal-permission-key"]),
      _createVNode(StatisticsCards, {
        "total-strategies": statistics.totalStrategies,
        "visible-count": statistics.visibleCount,
        "hidden-count": statistics.hiddenCount,
        "coverage-groups": statistics.coverageGroups
      }, null, 8, ["total-strategies", "visible-count", "hidden-count", "coverage-groups"]),
      _createVNode(PolicyManage, {
        style: {"height":"100%"},
        title: _ctx.$t('screenWatermark.policyList'),
        "normal-permission-key": _unref(PermissionFe).watermark_screen,
        "strategy-type": _unref(PolicyType).screenWatermark,
        "custom-cols": customCols.value,
        "trigger-time": "none",
        "show-group-selector": true,
        "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
        "edit-in-drawer": "",
        onHandleAction: handlePolicyAction,
        ref_key: "policyManageRef",
        ref: policyManageRef
      }, {
        headerRight: _withCtx(() => [
          _createElementVNode("a", _hoisted_2, [
            _createVNode(_component_CmSvgIcon, {
              name: "assets/icons/question-solid-blue",
              monochrome: "",
              color: "var(--el-svg-monochrome-grey)"
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('screenWatermark.viewHiddenTutorial')), 1)
          ])
        ]),
        "table__strategy.type-header": _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('screenWatermark.watermarkMode')) + " ", 1),
          _createVNode(_component_el_tooltip, {
            placement: "top",
            effect: "light"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.globalModeDesc')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.softwareModeDesc')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", null, [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/warn-border-gray",
                  monochrome: "",
                  size: 18,
                  color: "var(--el-svg-monochrome-grey)"
                })
              ])
            ]),
            _: 1
          })
        ]),
        "table__strategy.type": _withCtx(({ row }: { row?: StrategyListData }) => [
          row
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(watermarkModeLabel(row.strategy.type)), 1))
            : _createCommentVNode("", true)
        ]),
        "table__strategy.wmdata.fields": _withCtx(({ row }: { row?: StrategyListData }) => [
          row
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.strategy.wmdata.fields.map((v) => watermarkFieldLabel(v)).join('+')), 1))
            : _createCommentVNode("", true)
        ]),
        "table__strategy.wmdata.mark_type-header": _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('screenWatermark.watermarkType')) + " ", 1),
          _createVNode(_component_el_tooltip, {
            placement: "top",
            effect: "light"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.hiddenDesc')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.visibleDesc')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.customDesc')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", null, [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/warn-border-gray",
                  monochrome: "",
                  size: 18,
                  color: "var(--el-svg-monochrome-grey)"
                })
              ])
            ]),
            _: 1
          })
        ]),
        "table__strategy.wmdata.mark_type": _withCtx(({ row }: { row?: StrategyListData }) => [
          row
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(watermarkTypeLabel(row.strategy.wmdata.mark_type)), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "normal-permission-key", "strategy-type", "custom-cols", "terminal-type"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: policyEditDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((policyEditDrawerVisible).value = $event)),
      title: _ctx.$t('screenWatermark.strategyEdit'),
      size: "75%",
      "destroy-on-close": "",
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        (policyEditDrawerVisible.value)
          ? (_openBlock(), _createBlock(ScreenWatermarkEdit, {
              key: 0,
              "drawer-mode": "",
              "initial-policy-id": policyEditPolicyId.value,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (policyEditDrawerVisible.value = false)),
              onSuccess: onPolicyEditSuccess
            }, null, 8, ["initial-policy-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})